import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';


const mp_list = [
  {
    name: "shopee",
    link: "https://s.mooimom.id/t02Pt",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/shopee-no-bg.png"
  },
  {
    name: "tiktok",
    link: "https://s.mooimom.id/n7Oxa",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom/tiktok_2.png"
  },
  {
    name: "tokopedia",
    link: "https://s.mooimom.id/NsPx1",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/tokopedia-no-bg.png"
  },
  {
    name: "lazada",
    link: "https://s.mooimom.id/8OOpK",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/lazada-no-bg.png"
  },
  {
    name: "zalora",
    link: "https://s.mooimom.id/PMBap",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/zalora-no-bg.png"
  },
  {
    name: "blibli",
    link: "https://s.mooimom.id/gjnkp",
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/blibli-no-bg.png"
  },
]

const WelcomeMooimomMP = () => {
  const router = useRouter();

  return (
    <>
      <Head>
        <style>
          {`
            @media (max-width: 760px) {
              body {
                background-color: #EEEFF0 !important;
              }
            }
          `}
        </style>
      </Head>
      <div className="md:hidden">
        <div className="bg-gradient-to-b from-[#7EDDD0] to-[#38c9bd] h-20 flex justify-center items-center">
          <Link href="https://www.mooimom.id?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_logo">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/logo_w.png"}
              alt="MOOIMOM logo"
              quality={100}
              width={500}
              height={80}
              className="w-[200px]"
            />
          </Link>
        </div>
      </div>
      <div className="container hidden my-6 md:block">
        <Link href="https://www.mooimom.id?utm_source=instagram&utm_medium=profile&utm_campaign=mooimom_logo">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/logo2.png"}
            alt="MOOIMOM logo"
            quality={100}
            width={500}
            height={80}
            className="w-[200px]"
          />
        </Link>
      </div>
      <div className="container my-10 font-poppins md:w-1/2 md:mx-auto">
        <h3 className="mb-5 text-xl font-medium text-center md:font-bold">Official Marketplace</h3>
        <div className="bg-white rounded-2xl shadow-[0_1px_5px_0_#cecece] pt-4 pb-8 px-3">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/linktree-image/welcome-mooimom/mooimom-mp.jpg"}
            alt="MOOIMOM Marketplace"
            quality={100}
            width={450}
            height={100}
            className="w-[85%] mx-auto"
          />
          {mp_list.map((mp, index) => (
            <button
              className="w-full shadow-[0_1px_5px_0_#eaeaea] py-2 px-3 rounded mt-3"
              key={index}
              onClick={() => router.push(mp.link)}
            >
              <Image
                src={mp.image}
                alt={mp.name}
                quality={100}
                width={450}
                height={100}
                className="w-[120px] mx-auto"
              />
            </button>
          ))}
        </div>
        <p className="text-black my-10 text-[8px] text-center">Copyright © MOOIMOM CO., LTD. All Rights Reserved</p>
      </div>
    </>
  )
}

export default WelcomeMooimomMP
